import { render, staticRenderFns } from "./OfferDescription.vue?vue&type=template&id=ec3833b8&scoped=true&"
import script from "./OfferDescription.vue?vue&type=script&lang=js&"
export * from "./OfferDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3833b8",
  null
  
)

export default component.exports